/**
 * App header: app name and Share button.
 * Share opens the share dialog (tool vs results copy depending on shareContext).
 */
import React from 'react';

import { Button } from './ui/button';
import type { ScoreData } from '../types';
import { APP_CONFIG, HEADER_CONFIG } from '../constants';

interface HeaderProps {
  score: ScoreData;
  onShare: () => void;
  /** 'tool' = share the checklist; 'results' = share quiz results. Defaults to 'tool'. */
  shareContext?: 'tool' | 'results';
}

export const Header: React.FC<HeaderProps> = ({ onShare, shareContext = 'tool' }) => {
  const shareAriaLabel =
    shareContext === 'results' ? 'Share your assessment results' : 'Share this checklist';

  return (
    <header
      className="bg-transparent"
      style={{ height: `${HEADER_CONFIG.height}px` }}
      role="banner"
    >
      <div className="max-w-container mx-auto px-6 h-full flex items-center justify-between">
        <h1 className="text-sm font-semibold text-text-primary tracking-tight">
          {APP_CONFIG.name}
        </h1>
        <nav className="flex items-center gap-3" aria-label="Header actions">
          <Button
            onClick={onShare}
            variant="outline"
            size="sm"
            aria-label={shareAriaLabel}
          >
            Share
          </Button>
        </nav>
      </div>
    </header>
  );
};
